import { render } from "./ChargerSetup.vue?vue&type=template&id=186a4ba2"
import script from "./ChargerSetup.vue?vue&type=script&lang=js"
export * from "./ChargerSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__